import { gql } from '@apollo/client';

const GET_USER_MEMBERSHIP_DETAILS = gql`
  query getMembershipStatus {
    userHasPastVoloPassMembership
    userIsActiveVoloPassMember
    activeVoloPassMembership {
      stripeSubscriptionId
      stripePlanId
      planStartsAt
      planExpiresAt
      status
    }
    userHasPastVoloFitnessMembership
    userIsActiveVoloFitnessMember
    activeVoloFitnessMembership {
      stripeSubscriptionId
      stripePlanId
      planStartsAt
      planExpiresAt
      status
    }
  }
`;

export default GET_USER_MEMBERSHIP_DETAILS;
